import { lazy } from 'react';

import type { RouteConfig } from '../../types';

// Lazy load layouts
const DashboardLayout = lazy(() => import('@/layouts/DashboardLayout'));
const ProjectLayout = lazy(() => import('@/pages/projects/layout'));
const ProjectDetailLayout = lazy(() => import('@/pages/projects/[projectId]/layout'));
const SignDocumentsLayout = lazy(() => import('@/pages/projects/[projectId]/sign-documents/layout'));

// Lazy load project pages
const ProjectsPage = lazy(() => import('@/pages/projects'));
const ProjectMapPage = lazy(() => import('@/pages/projects/[projectId]/map'));
const ProjectReelsPage = lazy(() => import('@/pages/projects/[projectId]/reels'));
const SignDocumentsPage = lazy(() => import('@/pages/projects/[projectId]/sign-documents'));
const SignLegalDocumentsPage = lazy(() => import('@/pages/projects/[projectId]/sign-documents/legal'));
const SignOverallDocumentsPage = lazy(() => import('@/pages/projects/[projectId]/sign-documents/overall'));

/**
 * Project routes
 * Handles project viewing and management
 */
export const projectRoutes: RouteConfig = {
  path: '/projects',
  layout: DashboardLayout,
  children: [
    {
      path: '',
      layout: ProjectLayout,
      element: ProjectsPage,
    },
    {
      path: '/:projectId',
      layout: ProjectLayout,
      children: [
        {
          path: '/map',
          layout: ProjectDetailLayout,
          element: ProjectMapPage,
        },
        {
          path: '/reels',
          layout: ProjectDetailLayout,
          element: ProjectReelsPage,
        },
        {
          path: '/sign-documents',
          layout: ProjectDetailLayout,
          children: [
            {
              path: '',
              layout: SignDocumentsLayout,
              element: SignDocumentsPage,
            },
            {
              path: '/legal',
              layout: SignDocumentsLayout,
              element: SignLegalDocumentsPage,
            },
            {
              path: '/overall',
              layout: SignDocumentsLayout,
              element: SignOverallDocumentsPage,
            },
          ],
        },
      ],
    },
  ],
};
